(function () {
  if (!('IntersectionObserver' in window)) return;

  var STAGGER = 100;
  var MAX_DELAY = 500;

  var SELECTORS = [
    '[class*="__eyebrow"]',
    '[class*="__kicker"]',
    '[class*="__heading"]',
    '[class*="__title"]',
    '[class*="__subtitle"]',
    '[class*="__desc"]',
    '[class*="__text"]',
    '[class*="__cta"]',
    '[class*="__btn"]',
    '[class*="__button"]',
    '[class*="__card"]',
    '[class*="__item"]',
    '[class*="__col"]',
    '[class*="__panel"]',
    '[class*="__feature"]',
    '[class*="__stat"]',
    '[class*="__step"]',
    '[class*="__img-wrap"]',
    '[class*="__image-wrap"]',
    '.item',
    '.card',
    '.title',
    '.heading',
    '.subtitle',
    '.reveal-item',
    '.list',
  ].join(',');

  function getOutermostElements(section) {
    var all = Array.from(section.querySelectorAll(SELECTORS)).filter(function (el) {
      return !el.classList.contains('no-reveal');
    });
    return all.filter(function (el) {
      return !all.some(function (other) {
        return other !== el && other.contains(el);
      });
    });
  }

  function prepare(el, delay) {
    el.classList.add('scroll-reveal');
    if (delay > 0) el.style.setProperty('--reveal-delay', delay + 'ms');
  }

  function init() {
    var vh = window.innerHeight;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });

    document.querySelectorAll('.shopify-section').forEach(function (section) {
      var rect = section.getBoundingClientRect();
      if (rect.top < vh) return;

      var targets = getOutermostElements(section);

      if (targets.length > 0) {
        targets.sort(function (a, b) {
          return a.getBoundingClientRect().top - b.getBoundingClientRect().top;
        });
        targets.forEach(function (el, i) {
          prepare(el, Math.min(i * STAGGER, MAX_DELAY));
          observer.observe(el);
        });
      } else {
        prepare(section, 0);
        observer.observe(section);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
